import { makeStyles } from '@material-ui/core';

const styles = makeStyles((theme) => ({
  notificationArea: {
    maxHeight: 400,
    overflow: 'auto'
  },
  newNotification: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.common.white,
    borderRadius: 15,
    position: 'absolute',
    top: 0,
    right: 0
  },
  menuItem: {
    display: 'block',
    maxWidth: 300,
    whiteSpace: 'normal'
  }
}));

export default styles;
